<mat-form-field [appearance]="options?.appearance || 'standard'">
    <mat-label>
        {{options?.title}}
        <span class="asterisk" *ngIf="utils.isRequiredField(formControltypeMerchandise)">*</span>
    </mat-label>
    <ng-container [ngSwitch]="selectionType">
        <!-- Autocomplete -->
        <ng-container *ngSwitchCase="'autocomplete'">
            <input (keyup)="changeValue()" type="text" matInput id="typeMerchandise" [matAutocomplete]="auto"
                [formControl]="formControltypeMerchandise">
            <mat-autocomplete #auto="matAutocomplete" (optionSelected)="onSelectValue($event?.option?.value)"
                [displayWith]="displayFn" [returnWith]="returnFn">
                <mat-option *ngFor="let merchandise of filteredTypesMerchandiseOptions" [value]="merchandise"
                    [matTooltip]="merchandise.description">
                    <span>{{getOptionVisible(merchandise)}}</span>
                </mat-option>
            </mat-autocomplete>
        </ng-container>
        <!-- Select -->
        <ng-container *ngSwitchCase="'select'">
            <mat-select [formControl]="formControltypeMerchandise" id="typeMerchandise"
                (selectionChange)="onSelectValue($event?.value)" [compareWith]="compareByDescription">
                <mat-option *ngFor="let merchandise of filteredTypesMerchandiseOptions" [value]="merchandise"
                    [matTooltip]="merchandise.description">
                    <span>{{getOptionVisible(merchandise)}}</span>
                </mat-option>
            </mat-select>
        </ng-container>
    </ng-container>
    <mat-error *ngIf="formControltypeMerchandise?.errors?.required">
        {{ utils.giveMessageError('MANDATORY_FIELD') }}
    </mat-error>
</mat-form-field>